import React from 'react';

interface DashboardHeaderProps {
  title: string;
  lastUpdated: string;
  onRefresh?: () => void;
  refreshing?: boolean;
  goalTriggered?: boolean;
  currentEmojis?: string[];
}

function DashboardHeader({ 
  title, 
  lastUpdated,
  onRefresh,
  refreshing = false,
  goalTriggered = false,
  currentEmojis = ["🚀", "🎯"] 
}: DashboardHeaderProps) {
  // Ignoramos o título recebido por props e usamos um título mais atrativo
  const newTitle = "FUNCIONÁRIOS DIGITAIS";
  
  return (
    <div className="dashboard-header">
      <div className="dashboard-info">
        <h2 className="dashboard-title">
          <svg 
            className="dashboard-title-icon" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            fill="currentColor"
          >
            <path d="M18.901 1.153h1.048c1.548 0 2.942 1.395 2.942 2.942v16.8c0 1.548-1.395 2.942-2.942 2.942H4.043c-1.548 0-2.942-1.395-2.942-2.942v-16.8c0-1.548 1.395-2.942 2.942-2.942h1.101" 
            stroke="url(#paint0_linear)" strokeWidth="2.3" strokeLinecap="round"/>
            <path d="M7.655 1.153c0-.009 1.644 0 1.644 0 0 1.181.902 2.153 2.046 2.153 1.144 0 2.046-.972 2.046-2.153h1.661c.011 0 0 6.169 0 6.169-2.01 0-7.397 0-7.397 0s0-6.16 0-6.169z" 
            stroke="url(#paint1_linear)" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 14.8a2.8 2.8 0 100-5.6 2.8 2.8 0 000 5.6z" fill="url(#paint2_linear)"/>
            <path d="M19.6 12a7.6 7.6 0 11-15.2 0 7.6 7.6 0 0115.2 0z" stroke="url(#paint3_linear)" strokeWidth="2"/>
            <defs>
              <linearGradient id="paint0_linear" x1="12" y1="1.153" x2="12" y2="23.837" gradientUnits="userSpaceOnUse">
                <stop stopColor="#3B82F6"/>
                <stop offset="1" stopColor="#EC4899"/>
              </linearGradient>
              <linearGradient id="paint1_linear" x1="11.328" y1="1.153" x2="11.328" y2="7.322" gradientUnits="userSpaceOnUse">
                <stop stopColor="#8B5CF6"/>
                <stop offset="1" stopColor="#3B82F6"/>
              </linearGradient>
              <linearGradient id="paint2_linear" x1="12" y1="9.2" x2="12" y2="14.8" gradientUnits="userSpaceOnUse">
                <stop stopColor="#F43F5E"/>
                <stop offset="1" stopColor="#8B5CF6"/>
              </linearGradient>
              <linearGradient id="paint3_linear" x1="12" y1="4.4" x2="12" y2="19.6" gradientUnits="userSpaceOnUse">
                <stop stopColor="#3B82F6"/>
                <stop offset="1" stopColor="#8B5CF6"/>
              </linearGradient>
            </defs>
          </svg>
          <span className="dashboard-title-gradient">{newTitle}</span>
        </h2>
        <div className="last-updated">
          <span>Última atualização: {lastUpdated}</span>
          <div className="last-updated-indicator"></div>
        </div>
      </div>
      
      {onRefresh && (
        <button 
          onClick={onRefresh}
          disabled={refreshing}
          className={`update-button ${refreshing ? 'refreshing' : ''} ${goalTriggered ? 'goal-triggered' : ''}`}
        >
          <div className="sparkles">
            <div className="sparkle"></div>
            <div className="sparkle"></div>
            <div className="sparkle"></div>
            <div className="sparkle"></div>
          </div>
          
          {refreshing ? (
            <>
              <span className="update-button-icon update-button-icon-spin">
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
              <span className="font-bold">Atualizando dados...</span>
            </>
          ) : (
            <>
              <span className="update-button-icon">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </span>
              <span className="font-bold">Atualizar Dashboard</span>
              <span className="flex gap-1 items-center">
                <span>{currentEmojis[0]}</span>
                <span>{currentEmojis[1]}</span>
              </span>
            </>
          )}
        </button>
      )}
    </div>
  );
}

export default DashboardHeader;
